<div class="main-content">
  <div class="page-header-image">
    <img src="assets/branded/img/onboarding-start-bg.png" alt="" />
  </div>
  <div class="text-container">
    <div class="instruction-container">
      <h2>{{ 'onboarding.finished.detail' | transloco }}</h2>
      <p>{{ 'limited-app.instructions-invitation' | transloco }}</p>
      <p>{{ 'limited-app.troubleshooting' | transloco }}</p>
    </div>
    <a (click)="logout()" class="logout">
      <c-icon [icon]="faPowerOff" size="xl" />
      {{ 'my-profile.logout' | transloco }}
    </a>
  </div>
</div>
